<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="ASP待分批次等待补足监测"></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
    <div id="left_4" slot="main"/>
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "left_4",
  components: { ChartTitle,DateChangeCard },
  data() {
    return {
      chart: null,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("left_4"));
      this.setOptions();
    },
    setOptions() {
      const color = ["59,157,255", "34,228,255", "59,255,208", "4,227,138"];
      let chartData = [
        { value: 398 },
        { value: 428 },
        { value: 298 },
        { value: 128 },
        { value: 298 },
        { value: 418 },
        { value: 398 },
        { value: 198 },
        { value: 298 },
        { value: 300 },
        { value: 128 },
        { value: 328 },
        { value: 248 },
        { value: 178 },
        { value: 228 },
      ];
      chartData = chartData.map((m, i) => {
        return {
          value: m.value,
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                offset: 0,
                color: `rgba(${color[i % 4]},1)`,
              },
              {
                offset: 1,
                color: `rgba(${color[i % 4]},0.1)`,
              },
            ]),
          },
        };
      });
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: false,
        },
        grid: {
          left: "left",
          top: "10%",
          bottom:"4%",
          right:"14%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          axisLabel: {
            color: "#606266",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
              type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
            },
          },
        },
        yAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          axisLabel: {
            color: "#909399",
            fontSize: "10",
          },
          data: [
             "18-禾香-B729",
                 "18PET-加利胡桃",
                       "18挪威黑森林",
                       "18A-西雅图沙棕",
                       "18-禾香-B720",
                 "18PET-默然",
                       "18L-秋水长天",
                       "18PET-卡拉奇",
                       "18L-沙漠之旅1220*2440*18",
                 "18-千年舟-铁灰",
                       "18博纳克月明秋夜冷",
                 "18-鲁丽-胡桃木ENF",
                       "18L-陨石无标",
                       "18胡椒灰",
                       "18PET-柳絮白",
                 ],
        },
        series: [
          {
            name: "销售额（张）",
            type: "bar",
            right: "5%",
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
            },
            data: chartData,
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 60vh;
  #left_4 {
    height: calc(100% - 30px);
  }
}
</style>
